/* V20 — single product: gallery swap, specs accordion, assembly toggle. Plain JS. */
( function () {
	'use strict';

	/* ---- Gallery: thumbnail swaps the main image ---- */
	var mainImg = document.getElementById( 'pd-main-img' );
	var thumbs  = document.querySelectorAll( '.pd-thumb' );

	Array.prototype.forEach.call( thumbs, function ( thumb ) {
		thumb.addEventListener( 'click', function () {
			var full = thumb.getAttribute( 'data-full' );

			Array.prototype.forEach.call( thumbs, function ( t ) {
				t.classList.remove( 'is-active' );
			} );
			thumb.classList.add( 'is-active' );

			if ( ! full || ! mainImg || mainImg.src === full ) {
				return;
			}

			// Fade out, swap source, fade back in.
			mainImg.classList.add( 'is-fading' );
			setTimeout( function () {
				mainImg.src = full;
				mainImg.onload = function () {
					mainImg.classList.remove( 'is-fading' );
				};
				if ( mainImg.complete ) {
					mainImg.classList.remove( 'is-fading' );
				}
			}, 300 );
		} );
	} );

	/* ---- Specs accordion ---- */
	var header = document.querySelector( '.pd-accordion__header' );
	var body   = document.querySelector( '.pd-accordion__body' );

	if ( header && body ) {
		// Start open: remember full height for smooth collapse.
		body.style.maxHeight = body.scrollHeight + 'px';

		header.addEventListener( 'click', function () {
			var open = header.classList.toggle( 'is-open' );
			header.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
		} );

		// Keep height correct on resize while open.
		window.addEventListener( 'resize', function () {
			if ( header.classList.contains( 'is-open' ) ) {
				body.style.maxHeight = 'none';
				var h = body.scrollHeight;
				body.style.maxHeight = h + 'px';
			}
		} );
	}

	/* ---- Assembly (MONTEREN) toggle ---- */
	var asmBtn    = document.getElementById( 'pd-assembly-btn' );
	var asmInput  = document.getElementById( 'pd-assembly-input' );
	var asmStatus = document.getElementById( 'pd-assembly-status' );
	var priceEl   = document.querySelector( '.pd-price__amount' );

	// Format a number as "€ 1.049,00" (NL style).
	function euro( n ) {
		var parts = n.toFixed( 2 ).split( '.' );
		parts[0] = parts[0].replace( /\B(?=(\d{3})+(?!\d))/g, '.' );
		return '€ ' + parts[0] + ',' + parts[1];
	}

	if ( asmBtn && asmInput && asmStatus ) {
		var base = priceEl ? parseFloat( priceEl.getAttribute( 'data-base-price' ) ) : NaN;
		var fee  = priceEl ? parseFloat( priceEl.getAttribute( 'data-assembly-fee' ) ) : 0;
		var withAsm = priceEl ? parseFloat( priceEl.getAttribute( 'data-assembly-price' ) ) : NaN;

		var variantInput = document.querySelector( '.pd-form [name="id"]' );
		var variantNo    = asmBtn.getAttribute( 'data-variant-no' );
		var variantYes   = asmBtn.getAttribute( 'data-variant-yes' );

		asmBtn.addEventListener( 'click', function () {
			var on = asmBtn.classList.toggle( 'is-active' );
			asmInput.value = on ? '1' : '0';
			asmStatus.textContent = on ? 'Gekozen' : 'Niet gekozen';

			if ( variantInput && variantNo && variantYes ) {
				variantInput.value = on ? variantYes : variantNo;
			}

			if ( priceEl && ! isNaN( base ) ) {
				var next = on ? ( isNaN( withAsm ) ? base + fee : withAsm ) : base;
				priceEl.textContent = euro( next );
			}
		} );
	}

	/* ---- Desktop lightbox (opt-in via the zoom button) ---- */
	var zoomBtn = document.querySelector( '.pd-gallery__zoom' );
	if ( zoomBtn ) {
		var lbImgs = [];
		try {
			lbImgs = JSON.parse( zoomBtn.getAttribute( 'data-images' ) ) || [];
		} catch ( e ) {
			lbImgs = [];
		}

		if ( lbImgs.length ) {
			var ICON_X    = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z"/></svg>';
			var ICON_PREV = '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/></svg>';
			var ICON_NEXT = '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/></svg>';

			var lb = document.createElement( 'div' );
			lb.className = 'pd-lightbox';
			lb.setAttribute( 'role', 'dialog' );
			lb.setAttribute( 'aria-modal', 'true' );
			lb.innerHTML =
				'<button type="button" class="pd-lightbox__close" aria-label="Sluiten">' + ICON_X + '</button>' +
				'<button type="button" class="pd-lightbox__nav pd-lightbox__nav--prev" aria-label="Vorige">' + ICON_PREV + '</button>' +
				'<img class="pd-lightbox__img" src="" alt="">' +
				'<button type="button" class="pd-lightbox__nav pd-lightbox__nav--next" aria-label="Volgende">' + ICON_NEXT + '</button>' +
				'<div class="pd-lightbox__counter"></div>';
			document.body.appendChild( lb );

			var lbImg   = lb.querySelector( '.pd-lightbox__img' );
			var lbCount = lb.querySelector( '.pd-lightbox__counter' );
			var lbPrev  = lb.querySelector( '.pd-lightbox__nav--prev' );
			var lbNext  = lb.querySelector( '.pd-lightbox__nav--next' );
			var lbClose = lb.querySelector( '.pd-lightbox__close' );
			var lbIdx   = 0;

			if ( lbImgs.length < 2 ) {
				lbPrev.style.display = 'none';
				lbNext.style.display = 'none';
			}

			function lbShow( i ) {
				lbIdx = ( i + lbImgs.length ) % lbImgs.length;
				lbImg.src = lbImgs[ lbIdx ];
				lbCount.textContent = ( lbIdx + 1 ) + ' / ' + lbImgs.length;
			}

			function lbOpen() {
				// Start on whichever image is currently shown in the gallery, if we can match it.
				var start = 0;
				var cur = document.getElementById( 'pd-main-img' );
				if ( cur ) {
					var idx = lbImgs.indexOf( cur.getAttribute( 'src' ) );
					if ( idx > -1 ) {
						start = idx;
					}
				}
				lbShow( start );
				lb.classList.add( 'is-open' );
				document.body.style.overflow = 'hidden';
			}

			function lbCloseFn() {
				lb.classList.remove( 'is-open' );
				document.body.style.overflow = '';
			}

			zoomBtn.addEventListener( 'click', lbOpen );
			lbClose.addEventListener( 'click', lbCloseFn );
			lbNext.addEventListener( 'click', function () { lbShow( lbIdx + 1 ); } );
			lbPrev.addEventListener( 'click', function () { lbShow( lbIdx - 1 ); } );
			lb.addEventListener( 'click', function ( e ) {
				if ( e.target === lb ) {
					lbCloseFn();
				}
			} );
			document.addEventListener( 'keydown', function ( e ) {
				if ( ! lb.classList.contains( 'is-open' ) ) {
					return;
				}
				if ( 'Escape' === e.key ) {
					lbCloseFn();
				} else if ( 'ArrowRight' === e.key && lbImgs.length > 1 ) {
					lbShow( lbIdx + 1 );
				} else if ( 'ArrowLeft' === e.key && lbImgs.length > 1 ) {
					lbShow( lbIdx - 1 );
				}
			} );
		}
	}

	/* ---- Wishlist (Verlanglijst) — localStorage toggle, stores product data ---- */
	var wishBtn = document.getElementById( 'pd-wishlist-btn' );
	if ( wishBtn ) {
		var pid   = wishBtn.getAttribute( 'data-product-id' );
		var label = wishBtn.querySelector( '.pd-wishlist__label' );
		var KEY   = 'v20_wishlist';

		function wishGet() {
			var raw;
			try {
				raw = JSON.parse( localStorage.getItem( KEY ) ) || [];
			} catch ( e ) {
				raw = [];
			}
			// Normalise old format (array of ids) to objects.
			return raw.map( function ( item ) {
				return ( item && typeof item === 'object' ) ? item : { id: String( item ) };
			} );
		}

		function wishHas( list ) {
			for ( var i = 0; i < list.length; i++ ) {
				if ( String( list[ i ].id ) === String( pid ) ) {
					return i;
				}
			}
			return -1;
		}

		function wishRender() {
			var on = wishHas( wishGet() ) > -1;
			wishBtn.classList.toggle( 'is-active', on );
			wishBtn.setAttribute( 'aria-pressed', on ? 'true' : 'false' );
			if ( label ) {
				label.textContent = on ? 'In verlanglijst' : 'Verlanglijst';
			}
		}

		wishRender();

		wishBtn.addEventListener( 'click', function () {
			var list = wishGet();
			var at = wishHas( list );
			if ( at > -1 ) {
				list.splice( at, 1 );
			} else {
				list.push( {
					id:    pid,
					title: wishBtn.getAttribute( 'data-title' ) || '',
					price: wishBtn.getAttribute( 'data-price' ) || '',
					url:   wishBtn.getAttribute( 'data-url' ) || '',
					image: wishBtn.getAttribute( 'data-image' ) || '',
					motor: wishBtn.getAttribute( 'data-motor' ) || '',
					range: wishBtn.getAttribute( 'data-range' ) || ''
				} );
			}
			try {
				localStorage.setItem( KEY, JSON.stringify( list ) );
			} catch ( e ) {}
			wishRender();
		} );
	}
}() );
